import { render } from "./FormActions.vue?vue&type=template&id=a706e5e4&scoped=true"
import script from "./FormActions.vue?vue&type=script&lang=js"
export * from "./FormActions.vue?vue&type=script&lang=js"

import "./FormActions.vue?vue&type=style&index=0&id=a706e5e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a706e5e4"]])

export default __exports__